var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconInfoValue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5390F5",
    d: "M16.462,1.178H3.54c-1.302,0-2.361,1.059-2.361,2.361v12.921c0,1.301,1.059,2.361,2.361,2.361h12.922 c1.301,0,2.359-1.061,2.359-2.361V3.54C18.821,2.237,17.763,1.178,16.462,1.178z M9.271,15.367c-0.516,0-0.896-0.414-0.896-0.996 c0-0.348,0.132-0.879,0.397-2.023l0.516-2.174c0.065-0.315,0.132-0.581-0.083-0.581c-0.199,0-0.614,0.465-0.913,0.913l-0.315-0.265 c1.045-1.411,1.875-2.008,2.506-2.008c0.431,0,0.712,0.381,0.712,0.946c0,0.232-0.05,0.646-0.165,1.111l-0.813,3.386 c-0.117,0.48-0.117,0.662,0.132,0.662c0.265,0,0.747-0.381,1.161-0.863l0.299,0.268C10.879,14.787,9.967,15.367,9.271,15.367z  M10.831,7.055c-0.499,0-0.864-0.382-0.864-0.913c0-0.847,0.532-1.51,1.194-1.51c0.516,0,0.864,0.364,0.864,0.928 C12.025,6.375,11.477,7.055,10.831,7.055z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoValue);
export default __webpack_public_path__ + "static/media/icon-info-value.87cb5385.svg";
export { ForwardRef as ReactComponent };